// src/features/commission/components/CommissionWorkspaceHeader.tsx
import { PageHeader, formatPersianNumber } from '../../../app/components/foundation';
import type { Commission } from '../types/commission.types';
import { CommissionStatusBadge } from './CommissionStatusBadge';

export interface CommissionWorkspaceHeaderProps {
  commission: Commission;
}

/**
 * Top-of-page header for the commission workspace. Same choice
 * orders/components/OrderWorkspaceHeader.tsx makes: reuses the shared
 * PageHeader primitive directly instead of a custom Card layout —
 * commission number as the title, id as supporting description, and
 * the status badge in the actions slot (rendered inline with the
 * title, same as every other feature's PageHeader usage).
 */
export function CommissionWorkspaceHeader({ commission }: CommissionWorkspaceHeaderProps) {
  return (
    <PageHeader
      title={`کمیسیون ${formatPersianNumber(commission.id)}`}
      description={`نماینده: ${commission.representative_name || commission.mobile || commission.representative_id}`}
      actions={<CommissionStatusBadge status={commission.status} />}
    />
  );
}
